export default __webpack_public_path__ + "static/media/10.b64f96e6.JPG";